import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './index.css';
import 'react-photo-view/dist/react-photo-view.css';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// import AuthProvider from './context/AuthProvider';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();


// const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <QueryClientProvider client={queryClient}>
      <AuthProvider> */}
        <App />
      {/* </AuthProvider>
    </QueryClientProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
